class TeamMfaVerification{
    constructor()
    {
        this.formEvents();
        this.formHandlers();
    }

    formEvents(){
        const form = document.querySelector('#frm-teamMFAuthentication-verifyMFAForm');
        if(form){
            new MfaInputEvents(form);
        }
    }
    formHandlers(){
        const form          = document.getElementById('frm-teamMFAuthentication-verifyMFAForm');
        if(form){
            const fv            = new MfaInputValidator('frm-teamMFAuthentication-verifyMFAForm').enableMFAFormValidation();
            const submitButton  = document.getElementById('authorize-two-step-submit');
            const thisClass = this;
            if(form !== null){
                submitButton.addEventListener('click', function (e) {
                    e.preventDefault();
                    fv.validate().then(function(status) {
                        if(status === 'Valid'){
                            submitButton.setAttribute('data-kt-indicator', 'on');
                            submitButton.disabled = true;
                            $('#frm-teamMFAuthentication-verifyMFAForm').submit();
                        }else {
                            return;
                        }
                    });
                });
                $.nette.ext('teamMfaAuthorizationFormExt', {
                    success: function (payload, status, jqXHR, settings) {
                        let formID = settings.nette.form[0].attributes.id.value;
                        if(formID === 'frm-teamMFAuthentication-verifyMFAForm'){
                            submitButton.setAttribute('data-kt-indicator', 'off');
                            submitButton.disabled = false;
                        }
                    }
                });
            }
        }
    }
}

window.TeamMfaVerification = TeamMfaVerification;